<template>
    <svg
        :width="width"
        :height="height"
        version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">

        <rect width="20" height="20" opacity="0"/>
        <path class="svg-secondary-color" d="M16.5,6.9h-1.6V4.9C14.9,2.2,12.7,0,10,0C7.3,0,5.1,2.2,5.1,4.9v2.1H3.5C2.7,6.9,2,7.6,2,8.5v9.9
	C2,19.3,2.7,20,3.5,20h12.9c0.9,0,1.6-0.7,1.6-1.6V8.5C18,7.6,17.3,6.9,16.5,6.9z M6.2,4.9c0-2.1,1.7-3.8,3.8-3.8
	c2.1,0,3.8,1.7,3.8,3.8v2.1H6.2V4.9z M17,18.4c0,0.3-0.2,0.5-0.5,0.5H3.5c-0.3,0-0.5-0.2-0.5-0.5V8.5C3,8.2,3.3,8,3.5,8h12.9
	C16.7,8,17,8.2,17,8.5V18.4z M10,11.5c-0.6,0-1.1,0.5-1.1,1.1c0,0.3,0.1,0.6,0.4,0.8v1.6c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8
	v-1.6c0.2-0.2,0.4-0.5,0.4-0.8C11.1,12,10.6,11.5,10,11.5z"/>
</svg>
</template>

<script>
export default {
    name: "passwordIcon",
    props: {
        width: {
            type: Number,
            default: 20
        },
        height: {
            type: Number,
            default: 20
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/passwordIcon.vue